import { render, staticRenderFns } from "./PendingEmailVerify.vue?vue&type=template&id=516e8763"
import script from "./PendingEmailVerify.vue?vue&type=script&lang=js"
export * from "./PendingEmailVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports